/**
 * Cross-Sell i18n — a parte ANSIOSA (pt-BR + en-US).
 *
 * O bundle de cross-sell tinha ~21 kB de fonte e entrava na primeira pintura
 * porque o `App.tsx` o registrava no boot. Só três grupos de chaves são lidos
 * por código que está no grafo ansioso (`main.tsx`, MEDIDO por varredura do
 * mesmo percurso que o guard `grafoDoPrimeiroCarregamento` faz):
 *
 *  - `crossSell.sidebar` / `campaignsSidebar` / `catalogSidebar` — o menu lateral;
 *  - `crossSell.queue.*` — o ícone de fila de jobs do Header;
 *  - `crossSell.import.done.*` — o toast global de import concluído.
 *
 * Tudo o mais mora em `cross-sell.full.ts`, num pedaço preguiçoso que cada
 * módulo consumidor registra no PRÓPRIO escopo de módulo (antes do primeiro
 * render — um registro tardio não re-renderiza quem já montou, porque o
 * react-i18next não escuta `added` por padrão).
 *
 * Mesmo padrão de `shared/i18n/wave-e.ts`: deep merge no namespace
 * `translation`, sem tocar nos JSON gigantes. Idempotente.
 */
import i18n from 'i18next';

export const CROSS_SELL_EAGER_PT_BR = {
  crossSell: {
    sidebar: 'Importar clientes',
    campaignsSidebar: 'Campanhas',
    catalogSidebar: 'Importar catálogo',
    import: {
      done: {
        completedTitle: '✅ Import concluído',
        failedTitle: '❌ Import falhou',
        summary:
          '{{accounts}} empresas, {{assets}} produtos, {{decisores}} decisores prontos.',
        viewBase: 'Ver minha base →',
      },
    },
    queue: {
      iconLabel: 'Jobs de Cross-Sell',
      drawerTitle: 'Jobs em andamento',
      empty: 'Nenhum job em andamento.',
      viewDetail: 'Ver detalhe →',
      dismiss: 'Dispensar',
      offlineWarning:
        'Você ficou offline — alguns eventos podem ter sido perdidos.',
      reconnect: 'Recarregar para reconectar',
      jobImporting: 'Importando {{label}}',
      remaining: '{{value}} restantes',
    },
  },
} as const;

export const CROSS_SELL_EAGER_EN_US = {
  crossSell: {
    sidebar: 'Import clients',
    campaignsSidebar: 'Campaigns',
    catalogSidebar: 'Import catalog',
    import: {
      done: {
        completedTitle: '✅ Import completed',
        failedTitle: '❌ Import failed',
        summary:
          '{{accounts}} companies, {{assets}} products, {{decisores}} decision-makers ready.',
        viewBase: 'View my base →',
      },
    },
    queue: {
      iconLabel: 'Cross-Sell jobs',
      drawerTitle: 'Jobs in progress',
      empty: 'No jobs in progress.',
      viewDetail: 'View detail →',
      dismiss: 'Dismiss',
      offlineWarning: 'You went offline — some events may have been lost.',
      reconnect: 'Reload to reconnect',
      jobImporting: 'Importing {{label}}',
      remaining: '{{value}} remaining',
    },
  },
} as const;

let registered = false;

/** Registra as chaves ANSIOSAS de cross-sell no i18next. Idempotente. */
export function registerCrossSellTranslations(): void {
  if (registered) return;
  i18n.addResourceBundle('pt-BR', 'translation', CROSS_SELL_EAGER_PT_BR, /* deep */ true, /* overwrite */ true);
  i18n.addResourceBundle('en-US', 'translation', CROSS_SELL_EAGER_EN_US, /* deep */ true, /* overwrite */ true);
  registered = true;
}
